<template>
  <div class="card">
    <!----询比单信息------>
    <div v-if="showOrder" class="section">
      <div class="section-title">
        <base-section-title title="询比单信息" />
      </div>
      <div class="section-content">
        <jczh-descriptions
          :info="orderInfo"
          :option="orderOptions"
          :el-attrs="{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }"
        />
      </div>
    </div>
    <!---流标处理--->
    <div class="section">
      <div class="section-title">
        <base-section-title title="流标处理" />
      </div>
      <div class="section-content">
        <jczh-descriptions
          :info="auctionInfo"
          :option="options"
          :el-attrs="{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }"
        >
          <template v-slot:closeAttachmentIds>
            <upload
              ref="uploadFile"
              :file-id-before="auctionInfo.closeAttachmentIds"
              :props-data="{
                disabled: true,
                limit: 10,
                uploadMode: 'fileId',
                singleUpload: false
              }"
            />
          </template>
          <template v-slot:noticeContent>
            <u-editor v-model="auctionInfo.noticeContent" disabled />
          </template>
        </jczh-descriptions>
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="flowListing"
    />
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'
import Upload from '@/components/common/Upload/index.vue'

import { inquiryWhetherToPublishDict, inquiryAbnormalTypeDict, inquiryChargeStatusDict } from '@/dictionary/project/inquiry'
import {
  projectTypeDict,
  flowMarkDict,
  noticeReleaseStatusDict
} from '@/dictionary/project/common'

import {
  inquiryAbortiveInfoApi,
  getInquiryOrderApi
} from '@/api/procure/inquiry'
export default {
  components: {
    BaseSectionTitle,
    UEditor,
    RecordHistory,
    RecordRemark,
    Upload
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },
    showOrder: {
      type: Boolean,
      default: true
    },
    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      orderInfo: {},
      flowListing: [],
      orderOptions: [
        {
          label: '询比单名称',
          prop: 'orderName'
        },
        {
          label: '询比单编号',
          prop: 'orderCode'
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || ' - '
        },
        {
          label: '收货地址',
          prop: 'address',
          filter: value => {
            if (value?.receivingCountry === '中国') {
              return value?.receivingProvince
                ? `${value?.receivingProvince} ${value?.receivingCity} ${value?.receivingArea}`
                : ' - '
            } else {
              return value?.receivingCountry
            }
          }
        },
        {
          label: '详细地址',
          prop: 'address.address'
        }
      ],

      auctionInfo: {},
      options: [
        {
          label: '流标原因',
          prop: 'closeType',
          filter: value => inquiryAbnormalTypeDict.translate(value).label
        },
        {
          label: '流标原因',
          prop: 'closeReason',
          filter: value => flowMarkDict.translate(value).label
        },
        {
          label: '其他原因',
          prop: 'otherReason',
          hideFun: () =>
            this.auctionInfo?.closeReason !== flowMarkDict.OTHER.value
        },
        {
          label: '说明文件',
          slotName: 'closeAttachmentIds'
        },
        {
          label: '是否免收平台使用费',
          prop: 'signupFeeFree',
          filter: value => inquiryChargeStatusDict.translate(value).label,
          hideFun: () => this.auctionInfo?.closeType !== inquiryAbnormalTypeDict.RESTART.value
        },
        {
          label: '发布流标公告',
          prop: 'closePublicity',
          filter: value => inquiryWhetherToPublishDict.translate(value).label
        },
        {
          label: '发布日期',
          prop: 'releaseTime',
          isNormDay: true
        },
        {
          label: '发布状态',
          prop: 'noticeReleaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '流标公告标题',
          prop: 'noticeTitle'
        },
        {
          label: '流标公告内容',
          prop: 'noticeContent',
          slotName: 'noticeContent'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo?.order || {}
          this.getInfo()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getOrderInfo()
          this.getInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 获取询比单信息
     */
    getOrderInfo() {
      getInquiryOrderApi({ orderId: this.orderId })
        .then(res => {
          this.orderInfo = res?.data?.order || {}
          this.flowListing = res?.data?.flowListing || []
        })
        .catch(err => {
          console.error('获取询比单信息失败', err)
          this.$message.error(err.message || '获取询比单信息')
        })
    },
    // 获取流标处理信息
    getInfo() {
      if (!this.orderId) return
      inquiryAbortiveInfoApi(this.orderId)
        .then(res => {
          const data = res.data || {}
          this.auctionInfo = {
            closePublicity: data?.closePublicity,
            noticeTitle: data?.notice?.noticeTitle,
            noticeContent: data?.notice?.noticeContent,
            closeReason: data?.closeReason,
            closeType: data?.closeType,
            signupFeeFree: data?.signupFeeFree,
            otherReason: data?.otherReason,
            releaseTime: data?.notice?.noticePublishTime,
            noticeReleaseStatus: data?.notice?.noticeReleaseStatus,
            closeAttachmentIds: data?.closeAttachmentIds
          }
          if (this.auctionInfo.closeReason === flowMarkDict.OTHER.value) {
            this.options.splice(1, 0, {
              label: '其他原因',
              prop: 'otherReason'
            })
          }
          console.log('auctionInfo', this.auctionInfo)
          this.$emit('setAuctionInfo', this.auctionInfo)
        })
        .catch(err => {
          if (err) {
            this.$message.error(err.message || '获取信息失败')
          }
        })
    }
  }
}
</script>
